import { Row, Col } from 'components/Grid';
import { FeaturedEntityCard } from 'modules/Featured/components/FeaturedEntityCard';
import { getEntityId, getAppId, getUserId, getEntityTitle, getEntityDescription, getFooterItems, getEntityVisibility, getEntityName } from 'modules/Listings/helpers/entityCardUtils';
import { SupportedListingEntities } from 'modules/Listings/types';
import { useRouter } from 'next/router';
import { observer } from 'mobx-react-lite';
import { useCurrentStore } from 'modules/Listings/store/useCurrentStore';
import { SocialShare } from 'components/SocialShare';
import { Sorter } from 'modules/Listings/components/Sorter/Sorter';
import { css } from '@linaria/core';
import { EntityCard } from '../EntityCard/EntityCard';
import { StarComponent } from './components/Star/Star';
import { ScrollTrigger } from './ScrollTrigger';
import { LockComponent } from './components/Lock/Lock';
const communityPages = ['/explore', '/explore/models', '/explore/workflows', '/explore/modules'];
const List_: React.FC<{
  list: SupportedListingEntities[];
  makeUrl: (a: Record<string, string>) => string;
  pageName: string;
  parentWidth?: number;
  overrideUrlClick?: (entity: SupportedListingEntities) => void;
  getIsEntityOwner: (b: Record<string, string>) => boolean;
}> = ({
  list,
  makeUrl,
  getIsEntityOwner,
  overrideUrlClick,
  pageName,
  parentWidth = 1000
}): JSX.Element => {
  const store = useCurrentStore();
  const router = useRouter();
  const isCommunityPage = communityPages.includes(router.pathname);
  const isLandingPage = router.pathname === '/explore';
  const listCount = list.length;
  return <>
      {listCount > 0 && <Row justifyContent="space-between" className={metadataRow}>
          <Col>
            <p className="results-count">{listCount} Results</p>
          </Col>
          <Col>
            <Sorter />
          </Col>
        </Row>}
      <Row rowSpacing="10px" spacing="10px" data-testid={`list-${pageName}`}>
        {list.map((entity, entityIndex) => {
        const entityParams = {
          appId: getAppId(entity),
          userId: getUserId(entity),
          entityId: getEntityId(entity),
          entityTitle: getEntityTitle(entity)
        };
        const editableByOwner = getIsEntityOwner(entityParams);
        const href = makeUrl(entityParams);
        const items = getFooterItems(entity);
        const StarComp = 'is_starred' in entity ? <StarComponent entity={entity} /> : null;
        const isPublic = getEntityVisibility(entity) === 'PUBLIC';
        const ShareComp = isPublic ? <SocialShare pathname={href} /> : null;
        const entityName = router.pathname.includes('/datasets') ? 'datasets' : getEntityName(entity);
        const LockComp = !isPublic ? <LockComponent tooltipText={`This ${entityName} is private and not shared in Community`} /> : null;
        if (overrideUrlClick) {
          return <Col key={entityParams.entityTitle} width="100%">
                {isLandingPage ? <FeaturedEntityCard entityIndex={entityIndex} key={entityParams.entityId} onClick={() => overrideUrlClick(entity)} entity={entity} /> : <EntityCard key={entityParams.entityId} parentWidth={parentWidth} viewMode={store.viewMode} onClick={() => overrideUrlClick(entity)} pageName={pageName} title={entityParams.entityTitle} description={getEntityDescription(entity)} footerItems={items} share={ShareComp} star={StarComp} owner={!isCommunityPage && editableByOwner} entity={entity} lock={LockComp} />}
              </Col>;
        }
        return <Col key={entityParams.entityTitle} width="100%">
              {isLandingPage ? <FeaturedEntityCard entityIndex={entityIndex} key={entityParams.entityId} href={href} entity={entity} /> : <EntityCard key={entityParams.entityId} viewMode={store.viewMode} parentWidth={parentWidth} href={href} pageName={pageName} title={entityParams.entityTitle} description={getEntityDescription(entity)} footerItems={items} share={ShareComp} star={StarComp} lock={LockComp} owner={!isCommunityPage && editableByOwner} entity={entity} />}
            </Col>;
      })}
      </Row>
      <ScrollTrigger store={store} />
    </>;
};
export const List = observer(List_);
const metadataRow = "omponents__CommunitySearchModal__components__List__List_tsx-metadataRow-m1hvzjtm";

require("./List.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./List.tsx");